import Grid2 from "@mui/material/Unstable_Grid2";

function Footer() {
    return (
        <footer
            style={{
                height: "7vh",
                backgroundColor: "#282c34",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "calc(10px + 2vmin)",
                width: "100%",
                margin: "0",
                textAlign: "center",
                zIndex: "100",
                position: "relative",
            }}
        >
            <Grid2
                xs={12}
                sx={{
                    width: "60%",
                    fontSize: "1.0rem",
                    display: "flex",
                    justifyContent: "space-around",
                }}
            >
                <a
                    href="https://www.hd-plus.de/unternehmen/impressum"
                    className="footer-link"
                >
                    Impressum
                </a>
                <a
                    href="https://www.hd-plus.de/unternehmen/datenschutz"
                    className="footer-link"
                >
                    Datenschutz
                </a>
            </Grid2>
            <Grid2 stye={{ height: "20px", width: "100%", textAlign: "right" }}>
                <p
                    style={{
                        fontSize: "0.7rem",
                        margin: "0",
                        position: "absolute",
                        right: "5px",
                        bottom: "5px",
                    }}
                >
                    {process.env.REACT_APP_VERSION}
                </p>
            </Grid2>
        </footer>
    );
}

export default Footer;
